import type {
  ChangeFilter,
  FreeTextSearch,
  RowSelection,
  RunDataViewRequest
} from '@/api/contracts/dataModel';
import type { QueryFilterItem, QueryOrderByItem } from '@/api/contracts/queryResult';
import { wireText } from '@/helpers/wireText';

export interface BuildRunDataViewRequestInput {
  page?: number;
  pageSize?: number;
  filters: QueryFilterItem[];
  orderBy: QueryOrderByItem[];
  changes?: ChangeFilter | null;
  freeText?: FreeTextSearch | null;
  /**
   * US 3536: the row selection, described rather than listed. It travels with every page fetch
   * because the backend stores none of it, and the answer says how many rows are selected and which
   * of the rows on the page they are.
   */
  selection?: RowSelection | null;
}

export function buildRunDataViewRequest (input: BuildRunDataViewRequestInput): RunDataViewRequest {
  return {
    page: input.page ?? 1,
    pageSize: input.pageSize ?? 200,
    additionalFilters: input.filters.map((f) => ({
      tableAliasOrName: '',
      columnName: f.columnName,
      operator: f.operator,
      value: f.value != null ? wireText(f.value) : null,
      // US 3534: utelatt naar raden ikke baerer noen, saa backend beholder sin AND-default.
      ...(f.combinator ? { combinator: f.combinator } : {})
    })),
    orderByOverride: input.orderBy.map((o) => ({
      tableAliasOrName: '',
      columnName: o.columnName,
      ascending: o.direction === 'ASC'
    })),
    changes: input.changes ?? null,
    freeText: input.freeText ?? null,
    selection: input.selection ?? null
  };
}
